import { render, staticRenderFns } from "./workwechat.vue?vue&type=template&id=e3b4b3a8&scoped=true"
import script from "./workwechat.vue?vue&type=script&lang=js"
export * from "./workwechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b4b3a8",
  null
  
)

export default component.exports